import React from 'react'

import './loadingComponent.css'

const LoadComponent =()=>{

    return(
       <div className="w-screen h-96 flex items-center justify-center" >
            
                <div className="sm:transform sm:-translate-x-full ">

                  <div className="loader"></div>
                </div>
                
                  {/* <div className="loader2"></div> */}
    
       </div>
    )
}


export default LoadComponent;